export const enum PAGE_JOURNEY {
    LANDING_PAGE = 'LandingPage',
    LOGIN_PAGE = 'LoginPage',
    MAP_SELECTION_PAGE = 'MapSelectionPage',
    ENROLLMENT_PAGE = 'EnrollmentPage',
    CONFIRMATION_PAGE  = 'ConfirmationPage',
    ACCOUNT_SUMMARY_PAGE  = 'AccountSummaryPage',
    ERROR_PAGE = 'ErrorPage'
}

export const enum UtilityProvider {
    DTE = 'DTE',
    PGE = 'PG&E',
    NATIONAL_GRID = 'National Grid',
    PSE = 'PSE'
}

export const enum LOGIN_STATE {
    TRIGGERED = 'TRIGGERED',
    NOT_TRIGGERED = 'NOT_TRIGGERED',
    REDIRECTED = 'REDIRECTED',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
}

export const enum FORM_JOURNEY {
    ACKNOWLEDGEMENT = 'acknowledgement',
    ENROLLMENT = 'enrollment',
    CONFIRMATION = 'confirmation',
    COMPLETION = 'completion',
    NOT_ELIGIBLE_STATION = 'not_eligible_station',
    NOT_ELIGIBLE_HOME = 'not_eligible_home',
    INCOMPLETE = 'incomplete',
    FAILURE = 'failure',
    ALREADY_ENROLLED = 'already_enrolled',
    NO_VEHICLE = 'no_vehicle',
}
